const translations = {
  "en": {
    "Change": "Change",
    "Growth": "Growth",
    "Market Cap": "Market Cap",
    "Momentum": "Momentum",
    "Profitability": "Profitability",
    "Rating": "Rating",
    "Stock": "Stock",
    "Valuation": "Valuation"
  },
  "zh-tw": {
    "Change": "變更",
    "Growth": "成長",
    "Market Cap": "市值",
    "Momentum": "動能",
    "Profitability": "獲利能力",
    "Rating": "評分",
    "Stock": "股票",
    "Valuation": "估值"
  }
};

export default translations;
